export default class ApiResponse {
  constructor(response) {
    this.axiosResponse = response;
    this.status = response.data.status;
    this.data = response.data.data;
  }

  isSuccessful() {
    return this.status === 'success';
  }
}
